import { useMutation } from '@tanstack/react-query';
import { ISupportRequest } from '../../Interfaces/ISupportRequest';
import { customFetcher } from '../useFetch';

export const usePostSupportRequest = () => {
  const {
    mutateAsync: postSupportRequest,
    isPending: isPendingPostSupportRequest,
  } = useMutation({
    mutationFn: (supportRequest: ISupportRequest) =>
      customFetcher({
        endpoint: '/support',
        method: 'POST',
        body: supportRequest,
      }),
  });

  return { postSupportRequest, isPendingPostSupportRequest };
};
